import { gql } from '@apollo/client';

const Fragments = {
  genericEntityFlowItem: gql`
    fragment genericEntityFlowItem on GenericEntityFlow {
      id
      name
      siteId
      flowCode
      flowName
      freeTxt
      enabledYN
      context
      mainFlow
      preConditionProcedure
      postConditionProcedure
      genericEntityFlowStates {
        stateId
        isInitialState
        activeProduct
        flowId
        siteId
        editableYN
        deletePermitted
        stateColor
      }
    }
  `,
  generciEntityBusinessState: gql`
    fragment genericEntityBusinessState on GenericEntityBusinessState {
      stateId
      siteId
      stateCode
      stateName
      editableYN
      deletePermitted
      isActive
    }
  `
};

export default Fragments;
